import { createSlice } from '@reduxjs/toolkit';
import createGenericSlice, { GenericState } from '@/store/reducers/sliceTemplate';
import { fetchData } from '@/core/utils/fetchData';
import API_ENDPOINTS from '@/api/apiConfig';
import { HistoryItem } from '@/store/types/historyResultTypes';

const additionalState: Partial<GenericState<HistoryItem>> = {};

const historyResultSlice = createGenericSlice<HistoryItem>('historyResult', additionalState);

const combinedSlice = createSlice({
	name: 'historyResult',
	initialState: historyResultSlice.getInitialState(),
	reducers: {
		...historyResultSlice.caseReducers,
	},
});

export const {
	fetchDataStart,
	fetchDataError,
	setDataLoaded,
} = combinedSlice.actions;

export const fetchHistoryResultData = (id: number | null) => fetchData(combinedSlice, API_ENDPOINTS.historyResults)(id);

export default combinedSlice.reducer;
export { combinedSlice as historyResultSlice };
